export default "__VITE_ASSET__Bj0cxg27__"